// CSRF Token Utilities für Django CSRF-Protection
// Extrahiert CSRF-Token aus Cookie und stellt es für API-Requests bereit

/**
 * Extrahiert das CSRF-Token aus dem Browser-Cookie
 * @returns CSRF-Token oder null wenn nicht gefunden
 */
export const getCSRFToken = (): string | null => {
  const name = 'csrftoken';
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const token = parts.pop()?.split(';').shift();
    return token || null;
  }
  return null;
};

/**
 * Prüft ob ein CSRF-Token verfügbar ist
 * @returns true wenn Token vorhanden, false sonst
 */
export const hasCSRFToken = (): boolean => {
  return getCSRFToken() !== null;
};

/**
 * Validiert CSRF-Token Format (Django Standard)
 * @param token - Das zu validierende Token
 * @returns true wenn Format korrekt, false sonst
 */
export const isValidCSRFToken = (token: string | null): boolean => {
  if (!token) return false;
  // Django CSRF-Token: 32 Zeichen alphanumerisch
  return /^[a-zA-Z0-9]{32}$/.test(token);
};

/**
 * Debug-Informationen für CSRF-Token
 * @returns Objekt mit Token-Status und Debug-Info
 */
export const getCSRFTokenDebugInfo = () => {
  const token = getCSRFToken();
  return {
    hasToken: token !== null,
    tokenLength: token?.length || 0,
    isValid: isValidCSRFToken(token),
    tokenPreview: token ? `${token.substring(0, 8)}...` : null,
    allCookies: document.cookie.split(';').map(c => c.trim()),
  };
};

export default {
  getCSRFToken,
  hasCSRFToken,
  isValidCSRFToken,
  getCSRFTokenDebugInfo,
};
